import * as yup from "yup"

import { stringValidationYup } from "helpers/validations"
import { t } from "i18next"

const getTaskValidationSchema = () =>
  yup.object().shape({
    task: yup.string().required(t("Task is required")).nullable(),
    subTask: yup.string().required(t("Sub task is required")).nullable(),
    subofSubTask: yup.string().nullable(),
    subLocation: yup.string().required(t("Sub Location is required")).nullable(),
    leadsClassification: yup.string().required(t("Leads classification is required")),
    tsrClassification: yup.string().required(t("TSR classification is required")),
    completionDate: yup.object().required(t("Completion date is required")).nullable(),
    completionTime: yup.array().required("Completion time is required").nullable(),
    comment: stringValidationYup().required(t("Comment is required")).nullable(),
    nextTask: yup.string().nullable(),
    attachment: yup.array().of(yup.object().shape({ file: yup.mixed() })),
    verifyMeeting: yup
      .string()
      .nullable()
      .test({
        message: t("Verify meeting is required"),
        test: function (value, ctx) {
          if (this.parent.subTask?.id === 5 && value !== ")fulfilled" && value !== "pending") {
            return false
          }
          return true
        },
      }),
    deadLine: yup.object().required(t("Deadline is required")).nullable(),
    deadLineTime: yup.array().required("Deadline time is required").nullable(),
    dateSlot: yup.object().required(t("Deadline is required")).nullable(),
    timeSlot: yup.array().required(t("Time slot is required")).nullable(),
    salesEvent: yup.string().required(t("Sales event is required")).nullable(),
    meetingTime: yup.array().required(t("Meeting time is required")).nullable(),
    companyOffice: yup.string().required(t("Company office is required")).nullable(),
    visitedProject: yup.string().required(t("Visited project is required")).nullable(),
    plusCode: stringValidationYup().required(t("Plus code is required")).nullable(),
    newMeetingDate: yup.object().required(t("Meeting date is required")).nullable(),
    newMeetingTime: yup.array().required(t("Meeting time is required")).nullable(),
  })

export default getTaskValidationSchema
